import { combineReducers } from 'redux';
import {
  DIVIDER_CHANGE_COLOR,
  DIVIDER_CHANGE_WIDTH,
  DIVIDER_CHANGE_VERTICAL_PADDING,
} from '../actions/action-names';

const color = (state = '', action) => {
  switch (action.type) {
    case DIVIDER_CHANGE_COLOR:
      return action.value;
    default:
      return state;
  }
};

const width = (state = '', action) => {
  switch (action.type) {
    case DIVIDER_CHANGE_WIDTH:
      return action.value;
    default:
      return state;
  }
};

const verticalPadding = (state = '', action) => {
  switch (action.type) {
    case DIVIDER_CHANGE_VERTICAL_PADDING:
      return action.value;
    default:
      return state;
  }
};

export default combineReducers({
  color,
  width,
  verticalPadding,
});



// WEBPACK FOOTER //
// ./app/header-builder/reducers/divider-element-options-reducers.js